import Index from '../views/Regulacao/Index'
import Detail from '../views/Regulacao/Detail'

let routes = {
    path: '/regulacao',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/regulacao',
            name: 'regulacao',
            component: Index,
            meta: {
                pageTitle: 'Regulação',
                access_nivel: ['1', '2', '3'],
                breadcrumb: [
                    {
                        text: 'Regulação',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/regulacao/:id',
            name: 'regulacao-detail',
            component: Detail,
            meta: {
                pageTitle: 'Regulação',
                access_nivel: ['1', '2', '3'],
                breadcrumb: [
                    {
                        text: 'Regulação',
                        to: '/regulacao',
                    },
                    {
                        text: 'Detalhes',
                        active: true,
                    },
                ],
            },
        },
    ],
}

export default routes
